import Editable from './Editable';
import type { Translations, SeoData } from '../types';
import { assets } from '../assetsConfig';

interface HeroProps {
  t: Translations;
  seo: SeoData;
  isEditable: boolean;
  onUpdate: (key: string, val: string) => void;
}

export default function Hero({ t, seo, isEditable, onUpdate }: HeroProps) {
  return (
    <section id="hero" className="relative min-h-screen w-full flex items-center pt-24 pb-12 overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center transition-transform duration-[20s] hover:scale-110" 
        style={{ backgroundImage: `url(${assets.img.bg1})` }}
        role="img"
        aria-label={seo.heroAlt}
      ></div>
      <div className="absolute inset-0 hero-overlay"></div>
      
      <div className="container relative z-10 mx-auto px-4 flex flex-col justify-center max-w-4xl">
        <span className="text-care font-bold tracking-wider uppercase mb-2 flex items-center gap-2">
          <i className="ri-leaf-line"></i> 
          <Editable isEditable={isEditable} value={t.hero_title} onChange={(v) => onUpdate('hero_title', v)} as="span" />
        </span>
        
        <Editable 
          isEditable={isEditable} 
          value={t.hero_heading} 
          onChange={(v) => onUpdate('hero_heading', v)} 
          as="h1" 
          className="text-4xl sm:text-5xl md:text-5xl lg:text-6xl font-extrabold text-prestige leading-[1.15] py-2" 
          multiline 
        />
        
        <Editable 
          isEditable={isEditable} 
          value={t.hero_subtitle} 
          onChange={(v) => onUpdate('hero_subtitle', v)} 
          as="div" 
          className="mt-6 text-lg sm:text-xl font-bold text-slate-800 leading-relaxed max-w-2xl drop-shadow-md py-2" 
          multiline 
        />
        
        <div className="mt-10 flex flex-col sm:flex-row gap-4">
          <a href={t.contact_wa_link} target="_blank" rel="noopener noreferrer" onClick={(e) => isEditable && e.preventDefault()} aria-label={t.hero_btn_contact || 'WhatsApp'} className="cursor-pointer group px-8 py-4 bg-[#125b60] text-white font-bold rounded-full shadow-lg hover:-translate-y-1 hover:shadow-xl hover:bg-[#104f53] transition-all duration-300 text-center flex items-center justify-center gap-3">
            <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform" aria-hidden="true"></i>
            <Editable isEditable={isEditable} value={t.hero_btn_contact} onChange={(v) => onUpdate('hero_btn_contact', v)} as="span" />
          </a>
          <a href="#ueber-uns" onClick={(e) => isEditable && e.preventDefault()} className="cursor-pointer group px-8 py-4 bg-transparent text-prestige border-2 border-prestige font-bold rounded-full hover:bg-prestige hover:text-white transition-all duration-300 text-center flex items-center justify-center gap-2 hover:-translate-y-1">
            <Editable isEditable={isEditable} value={t.hero_btn_more} onChange={(v) => onUpdate('hero_btn_more', v)} as="span" />
            <i className="ri-arrow-down-line group-hover:translate-y-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}